import { fillLayers, matchColor, pick, type LayerStyle } from "./types";

const AB = "#d9480f";
const C = "#aa711d";

const style: LayerStyle = {
  id: "coa-wui",
  minzoom: 9,
  maxzoom: 14,
  layers(source) {
    return fillLayers(this, source, matchColor("WUICode", [["Proximity Zones A and B", AB], ["Proximity Zone C", C]]), 0.25);
  },
  legend: [
    { label: "Proximity zones A and B (closest to wildland)", color: AB },
    { label: "Proximity zone C", color: C },
  ],
  describe: (p) => pick(p, [["WUICode", "Wildland-urban interface"]]),
};

export default style;
